import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { IconTick } from '@xing-com/icons';

import { useDeckCardTyped } from '../../context';

import { Item, FactsContainer } from './facts.styled';

export const Facts: React.FC = () => {
  const { data } = useDeckCardTyped(['TakenJob', 'AvailableJob'] as const);
  const { isLoggedOut } = useLoginState();

  if (
    (!isLoggedOut && !data?.matchingHighlights) ||
    (isLoggedOut && !data?.paid && !data?.employmentType)
  ) {
    return null;
  }

  const matchingFacts = data?.matchingHighlights?.matchingFacts.filter(
    (fact) => fact.type !== 'job_keyfact_salary'
  );
  const nonMatchingFacts = (
    data?.matchingHighlights?.nonMatchingFacts || []
  ).filter((fact) => fact.type !== 'job_keyfact_salary');

  if (isLoggedOut && !nonMatchingFacts.length) {
    if (data.paid) {
      nonMatchingFacts.push({
        type: 'job_keyfact_verified',
        localization: {
          localizationValue: 'Verified job ad',
        },
      });
    }
    if (data.employmentType) {
      nonMatchingFacts.push({
        type: 'job_keyfact_employment_type',
        localization: {
          localizationValue: data.employmentType.localizationValue,
        },
      });
    }
  }

  return (
    <FactsContainer>
      {nonMatchingFacts?.map((fact, index) => (
        <Item key={'nonMatch' + index}>
          {fact.localization.localizationValue}
        </Item>
      ))}
      {matchingFacts?.map((fact, index) => (
        <Item key={'match' + index} icon={IconTick} variant="match">
          {fact.localization.localizationValue}
        </Item>
      ))}
    </FactsContainer>
  );
};
